import React from 'react';
import HeroSection from '@/components/sections/marketplace/HeroSection';
import PricingSection from '@/components/sections/marketplace/PricingSection';
import AdvantagesSection from '@/components/sections/marketplace/AdvantagesSection';
import ContactForm from '@/components/sections/marketplace/ContactForm';
import CTASection from '@/components/sections/marketplace/CTASection';
import MultiPlatformHighlight from '@/components/sections/highlights/MultiPlatformHighlight';
import SEO from '@/components/SEO';
import FAQ from '@/components/ui/FAQ';
import BookingModule from '@/components/sections/BookingModule';

const MarketplaceDevelopment = () => {
  const faqItems = [
    {
      question: "Quelles fonctionnalités sont essentielles pour une marketplace ?",
      answer: "Une marketplace moderne nécessite : inscription vendeurs/acheteurs, gestion des produits/services, système de paiement sécurisé avec commission, messagerie interne, système de notation et avis, tableau de bord analytics, et gestion des litiges. Nous implémentons toutes ces fonctionnalités de manière personnalisée."
    },
    {
      question: "Comment gérez-vous les paiements et les commissions ?",
      answer: "Nous intégrons des solutions de paiement sécurisées comme Stripe Connect, qui permettent de gérer automatiquement les paiements entre acheteurs et vendeurs avec prélèvement de commission. Le système gère également les remboursements, les paiements différés et la génération de factures."
    },
    {
      question: "Comment assurez-vous la qualité des vendeurs et des produits ?",
      answer: "Nous mettons en place des systèmes de vérification des vendeurs, modération des annonces, notation des transactions, et gestion des avis. Nous pouvons également implémenter des algorithmes de détection de fraude et des processus de vérification KYC."
    },
    {
      question: "La marketplace sera-t-elle optimisée pour mobile ?",
      answer: "Oui, nous développons en mobile-first avec un design responsive. La marketplace est optimisée pour tous les appareils avec une expérience utilisateur cohérente. Nous pouvons également développer des applications mobiles natives si nécessaire."
    },
    {
      question: "Comment gérez-vous la montée en charge ?",
      answer: "L'architecture est conçue pour la scalabilité : infrastructure cloud élastique, bases de données optimisées, mise en cache distribuée, et CDN pour les médias. Nous utilisons des technologies comme Elasticsearch pour des recherches rapides même avec des millions de produits."
    },
    {
      question: "Quels outils proposez-vous pour les vendeurs ?",
      answer: "Nous développons des outils complets : tableau de bord de gestion des produits, analytics des ventes, gestion des commandes et du stock, outils de promotion, système de messagerie, et API pour l'intégration avec leurs systèmes existants."
    }
  ];

  return (
    <>
      <SEO 
        title="Développement Marketplace | Solutions E-commerce B2B et B2C"
        description="Créez votre marketplace sur mesure avec Orcsys. Solutions e-commerce B2B et B2C performantes, sécurisées et évolutives pour digitaliser votre activité. Expertise en paiements sécurisés, gestion multi-vendeurs et expérience utilisateur."
        keywords="marketplace, e-commerce, développement web, B2B, B2C, plateforme de vente en ligne, solution e-commerce, multi-vendeurs, paiement sécurisé, gestion commission, système de notation"
        type="service"
        url="https://innov.orcsys.fr/developpement-marketplace"
        image="https://innov.orcsys.fr/images/marketplace-development-preview.jpg"
      />
      <div className="min-h-screen bg-white">
        <HeroSection />
        <AdvantagesSection />
        <PricingSection />
        <MultiPlatformHighlight 
          title="Lecoindine - La marketplace éthique et engagée"
          description="Une plateforme qui connecte vendeurs et acheteurs autour de produits authentiques et responsables. Disponible sur web et mobile, elle offre une expérience d'achat et de vente fluide et sécurisée."
          imageUrl="/images/lecoindine-image1.png"
          mobileImageUrl="/images/lecoindine-image2.png"
          storeRatings={{
            playStore: {
              rating: 4.5,
              reviews: 15,
              url: "https://play.google.com/store/apps/details?id=com.orcsys.lecoindine"
            },
            appStore: {
              rating: 4.3,
              reviews: 20,
              url: "https://apps.apple.com/fr/app/lecoindine-le-march%C3%A9-%C3%A9thique/id6476780044"
            }
          }}
          stats={{
            users: 2500,
            pageViews: 10000,
            downloads: 5000,
          }}
          metrics={{
            webPerformance: 88,
            mobilePerformance: 92,
            crossPlatformSync: 95
          }}
          interestingFact="Depuis son lancement, Lecoindine a permis à de nombreux vendeurs d'élargir leur audience et d'augmenter significativement leurs ventes."
        />
       
        <ContactForm />
        <CTASection />
        <BookingModule />
        <FAQ 
          title="Questions Fréquentes sur le Développement de Marketplace"
          subtitle="Découvrez comment nous créons des marketplaces performantes et évolutives"
          items={faqItems}
          className="bg-slate-50"
        />
      </div>
    </>
  );
};

export default MarketplaceDevelopment; 